import React from 'react';
import { List, Map } from 'immutable';
import { Route } from 'react-router-dom';
import comm from '../../../core/comm/actions';
import qcomm from '../../../core/comm/queries';
import qcache from '../../../core/cache/queries';
import qform from '../../../core/components/form/queries';
import { Request, Response } from '../../../core/comm';
import View from '../../../components/View';
import { bindActionCreatorsAndSubscribes } from '../../../core/util';
import ChangeEmailView from './ChangeEmailView';

const applet = '/p/redefinir_email';
const view = `${applet}/:cid`;

const urls = {
  get: {
    validateCid: '/v1/pub/validar_solicitacao_email/:cid',
  },
  post: {
    changeEmail: '/v1/pub/redefinicao_email_senha/:solicitacao',
  },
};

function query(data) {
  return data;
}

function validateCid(ownProps) {
  const { requestProps } = ownProps;
  const { cid } = requestProps.match.params;

  return comm.get(
    Request({
      view,
      url: urls.get.validateCid,
      urlParams: Map({ cid }),
      onSuccess: Response({
        transform: (data) => data.get(0),
      }),
    }),
  );
}

function changeEmail(codSolicitation, data) {
  return comm.post(
    Request({
      view,
      data,
      url: urls.post.changeEmail,
      urlParams: Map({ solicitacao: codSolicitation }),
      onSuccess: Response({
        transform: (data) => data.get(0),
        dispatch: List([() => comm.refresh('/')]),
      }),
    }),
  );
}

function mapStateToProps(state, ownProps) {
  const { requestProps } = ownProps;
  const { cid } = requestProps.match.params;
  return {
    cid,
    formState: qform.queryData(state, view, 'form', query),
    confirmationData:
      qcache.getData(state, view, urls.get.validateCid) || Map(),
    isSaving: qcomm.isLoading(state, view, urls.post.changeEmail),
    isValidating: qcomm.isLoading(state, view, urls.get.validateCid),
  };
}

function mapDispatchToProps(dispatch) {
  const actions = { changeEmail };
  const subs = { validateCid };
  return bindActionCreatorsAndSubscribes(actions, subs, dispatch);
}

const renderer = View.createRenderer(
  {
    component: ChangeEmailView,
    applet,
    view,
  },
  mapStateToProps,
  mapDispatchToProps,
);

export default <Route exact path={view} render={renderer} />;
